



























































































/* eslint-disable */
// @ts-nocheck

import Vue from "vue";
import { GridLayout, GridItem } from "vue-grid-layout";
import { charts } from "../../dcreator";

interface IItem {
  x: number;
  y: number;
  w: number;
  h: number;
  i: number;
  edit: boolean;
  title: string | null;
  chart: {
    type: string;
    options: {};
    series: [];
  };
}


export default Vue.extend({
  data: () => ({
    layout: [],
    editable: true,
    valid: false,
    chratypes: [
      {
        id: "bar",
        text: "Barras"
      },
      {
        id: "line",
        text: "Línea"
      },
      {
        id: "candlestick",
        text: "Candlestick"
      },
      {
        id: "pie",
        text: "Torta"
      }
    ],
    rules: [v => !!v || "El campo es requerido"]
  }),
  components: {
    GridLayout,
    GridItem
  },
  methods: {
    addPanel() {
      this.editable = true;
      this.layout.push({
        x: 0,
        y: 0,
        w: 3,
        h: 2,
        i: this.layout.length + 1,
        edit: true,
        title: null,
        chart: {
          type: "",
          options: {},
          series: []
        }
      });
    },
    toggleEditable() {
      this.editable = !this.editable;
    },
    generate(item: IItem) {
      // if (this.$refs.form.validate()) {
        const { options, series } = charts[item.chart.type]
        item.chart.options = options;
        item.chart.series = series;
      // }
    }
  }
});
